{
  "periods_controls.committed": "{{title}} now runs {{range}}",
  "periods_controls.cancelled": "Move cancelled; original dates restored"
}
